const withRenderedMain = require('components-framework/view/with_rendered_main');
module.exports = withRenderedMain(Backbone.View);
